import { useCallback } from 'react'
import { DrawerEvent, DrawerEventType } from '@typesApp/AppEvent'
import { useOpenDrawer } from '@hooks/useOpenDrawer'

export const useAppDrawerEventListener = (): EventListenerOrEventListenerObject => {
  const { openDrawer } = useOpenDrawer()

  const eventListener = useCallback(
    (event: Event) => {
      if (!isCustomEvent(event)) return

      const eventHandlers = {
        onOpenDrawer: event => event.type === 'onOpenDrawer' && openDrawer(event.payload),
      } as Record<DrawerEventType, (event: DrawerEvent) => void>

      const drawerEvent = event?.detail
      if (drawerEvent?.type) {
        eventHandlers[drawerEvent.type]?.(drawerEvent)
      }
    },
    [openDrawer]
  )

  return eventListener
}

const isCustomEvent = (event: Event): event is CustomEvent<DrawerEvent> => {
  return event instanceof CustomEvent
}
